import React from "react";
import "../Blog/blog.scss";
import { AnimatedOnScroll } from "react-animated-css-onscroll";
import Download from "../../Assets/Images/download.png";

const Blog = () => {
  return (
    <>
    <div className="blog-main">
      <div className="common-banner">
        <div className="container">
          <div className="common-head">
            <div className="line-head">
              <p>Check out our Latest News!</p>
            </div>
            <h1>Blog</h1>
          </div>
          <p className="text-center">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod Ut enim ad minim veniam. Lorem ipsum dolor sit amet
            adipisicing.
          </p>
        </div>
      </div>

      <div className="container">
        <div className="blog-flow">
          <div className="row">
            <div className="col-md-4 col-lg-3">
              <div className="blog-sidemenu">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search here..."
                  />
                  <button>
                    <span>
                      <i class="fas fa-search"></i>
                    </span>
                  </button>
                </div>
                <h5 className="sub-heading">categories</h5>
                <ul>
                  <li>
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                    <p>Category 01</p>
                  </li>
                  <li>
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                    <p>Category 02</p>
                  </li>
                  <li>
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                    <p>Category 03</p>
                  </li>
                  <li>
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                    <p>Category 04</p>
                  </li>
                  <li>
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                    <p>Category 05</p>
                  </li>
                  <li>
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                    <p>Category 06</p>
                  </li>
                  <li>
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                    <p>Category 07</p>
                  </li>
                  <li>
                    <span>
                      <i class="fas fa-chevron-right"></i>
                    </span>
                    <p>Category 08</p>
                  </li>
                </ul>

                <div className="tabination-menu">
                  <div className="tab-btn-group">
                    <button className="active">Popular</button>
                    <button>Recent</button>
                  </div>

                  <ul>
                    <li>
                      <div className="tab-img">
                        <img src={Download} />
                      </div>
                      <div className="blog-date">
                        <h6>Loren ipsum dolor sit amet sit</h6>
                        <p>Nov 10, 2021</p>
                      </div>
                    </li>
                    <li>
                      <div className="tab-img">
                        <img src={Download} />
                      </div>
                      <div className="blog-date">
                        <h6>Loren ipsum dolor sit amet sit</h6>
                        <p>Nov 10, 2021</p>
                      </div>
                    </li>
                    <li>
                      <div className="tab-img">
                        <img src={Download} />
                      </div>
                      <div className="blog-date">
                        <h6>Loren ipsum dolor sit amet sit</h6>
                        <p>Nov 10, 2021</p>
                      </div>
                    </li>
                    <li>
                      <div className="tab-img">
                        <img src={Download} />
                      </div>
                      <div className="blog-date">
                        <h6>Loren ipsum dolor sit amet sit</h6>
                        <p>Nov 10, 2021</p>
                      </div>
                    </li>
                    <li>
                      <div className="tab-img">
                        <img src={Download} />
                      </div>
                      <div className="blog-date">
                        <h6>Loren ipsum dolor sit amet sit</h6>
                        <p>Nov 10, 2021</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-8 col-lg-9">
              <div className="blog-description">
                <AnimatedOnScroll
                  animationIn="bounceInDown"
                  animationInDuration={2000}
                >
                  <div className="blog-desc-img-sub">
                    <img src={Download} />
                  </div>
                </AnimatedOnScroll>
                <div className="listof-review-desc">
                  <div className="trend">
                    <span>
                      <i class="far fa-user"></i>
                    </span>
                    <p>By Bob Doe</p>
                  </div>
                  <div className="trend">
                    <span>
                      <i class="far fa-folder"></i>
                    </span>
                    <p>eCommerce</p>
                  </div>
                  <div className="trend">
                    <span>
                      <i class="far fa-comment-alt"></i>
                    </span>
                    <p>12 Comments</p>
                  </div>
                </div>
                <h4>Shopping Trends of 2021</h4>

                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod Ut enim ad. Lorem ipsum dolor sit amet. Lorem ipsum
                  dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                  Ut enim ad. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit, sed do eiusmod Ut enim ad.
                  Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
                  consectetur adipisicing elit, sed do eiusmod Ut enim ad.
                </p>
                <p>
                  Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
                  consectetur adipisicing elit, sed do eiusmod Ut enim ad. Lorem
                  ipsum dolor sit amet. Lorem ipsum dolor sit amet, consectetur
                  adipisicing elit, sed do eiusmod Ut enim ad. Lorem ipsum dolor
                  sit amet. Lorem ipsum dolor sit amet, consectetur adipisicing
                  elit, sed do eiusmod Ut enim ad. Lorem ipsum dolor sit amet.
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod Ut enim ad. Lorem ipsum dolor sit amet.
                </p>
                <p>
                  {" "}
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod Ut enim ad. Lorem ipsum dolor sit amet. Lorem ipsum
                  dolor sit amet. Lorem ipsum dolor sit amet, consectetur
                  adipisicing elit, sed do eiusmod Ut enim ad. Lorem ipsum dolor
                  sit amet.
                </p>
                <p>
                  {" "}
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod Ut enim ad. Lorem ipsum dolor sit amet. Lorem ipsum
                  dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                  Ut enim ad. Lorem ipsum dolor sit amet.
                </p>

                <h5>Share this post</h5>
                <div className="button-share">
                  <button>
                    <span>
                      <i class="fas fa-thumbs-up"></i>
                    </span>
                    Like 1
                  </button>
                  <button>
                    <span>
                      <i class="fab fa-twitter"></i>
                    </span>
                    Twitter
                  </button>
                  <button>
                    <span>
                      <i class="fas fa-share"></i>
                    </span>
                    Share
                  </button>
                </div>
              </div>

              {/* please don't remove comment */}
              {/* <div className="row">
                <div className="col-md-6">
                  <div className="blog-collection">
                    <div className="blog-collection-img">
                      <img src={MapImg} />
                    </div>
                    <h4>Shopping Trends of 2021</h4>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod Ut enim ad. Lorem ipsum dolor sit amet.
                    </p>
                    <div className="listof-review">
                      <div className="trend">
                        <span>
                          <i class="far fa-user"></i>
                        </span>
                        <p>By Bob Doe</p>
                      </div>
                      <div className="trend">
                        <span>
                          <i class="far fa-folder"></i>
                        </span>
                        <p>eCommerce</p>
                      </div>
                      <div className="trend">
                        <span>
                          <i class="far fa-comment-alt"></i>
                        </span>
                        <p>12 Comments</p>
                      </div>
                    </div>
                    <p className="blog-read-more">Read More</p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="blog-collection">
                    <div className="blog-collection-img">
                      <img src={MapImg} />
                    </div>
                    <h4>Unlimited Ways</h4>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod Ut enim ad. Lorem ipsum dolor sit amet.
                    </p>
                    <div className="listof-review">
                      <div className="trend">
                        <span>
                          <i class="far fa-user"></i>
                        </span>
                        <p>By Bob Doe</p>
                      </div>
                      <div className="trend">
                        <span>
                          <i class="far fa-folder"></i>
                        </span>
                        <p>eCommerce</p>
                      </div>
                      <div className="trend">
                        <span>
                          <i class="far fa-comment-alt"></i>
                        </span>
                        <p>12 Comments</p>
                      </div>
                    </div>
                    <p className="blog-read-more">Read More</p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="blog-collection">
                    <div className="blog-collection-img">
                      <img src={MapImg} />
                    </div>
                    <h4>Shopping Trends of 2021</h4>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod Ut enim ad. Lorem ipsum dolor sit amet.
                    </p>
                    <div className="listof-review">
                      <div className="trend">
                        <span>
                          <i class="far fa-user"></i>
                        </span>
                        <p>By Bob Doe</p>
                      </div>
                      <div className="trend">
                        <span>
                          <i class="far fa-folder"></i>
                        </span>
                        <p>eCommerce</p>
                      </div>
                      <div className="trend">
                        <span>
                          <i class="far fa-comment-alt"></i>
                        </span>
                        <p>12 Comments</p>
                      </div>
                    </div>
                    <p className="blog-read-more">Read More</p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="blog-collection">
                    <div className="blog-collection-img">
                      <img src={MapImg} />
                    </div>
                    <h4>Shopping Trends of 2021</h4>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod Ut enim ad. Lorem ipsum dolor sit amet.
                    </p>
                    <div className="listof-review">
                      <div className="trend">
                        <span>
                          <i class="far fa-user"></i>
                        </span>
                        <p>By Bob Doe</p>
                      </div>
                      <div className="trend">
                        <span>
                          <i class="far fa-folder"></i>
                        </span>
                        <p>eCommerce</p>
                      </div>
                      <div className="trend">
                        <span>
                          <i class="far fa-comment-alt"></i>
                        </span>
                        <p>12 Comments</p>
                      </div>
                    </div>
                    <p className="blog-read-more">Read More</p>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <button className="yellow-btn">View More</button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Blog;
